import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import {MessagingService} from './messaging.service';
import {User} from '../shared/models/user';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Subject} from 'rxjs/Subject';
import {UserService} from './user.service';
import {ApiUserService} from './api-user.service';

@Injectable()
export class OrganizationService {
  // to-be-removed
  public organizations;
  public currentUser;
  public currentRoute;

  private _orgUrl: string = environment.baseUrl + '/orgs';
  private _apiUsers: string = environment.baseUrl + '/apiusers';
  private _contractUrl: string = environment.wpContractUrl;
  private _wpAuth: string = environment.wpAuth;

  // observable subjects
  public updatableOrgSubject: Subject<any> = new BehaviorSubject<User>(null);
  public newOrgSubject: Subject<any> = new BehaviorSubject<User>(null);

  constructor(private http: Http,
              private userService: UserService,
              private apiUserService: ApiUserService,
              public msgService: MessagingService) {

    this.currentUser = this.userService.currentUserSubject.getValue();

    this.organizations = [
      {
        title: 'StreamUK',
        id: 'STREAMUK'
      },
      {
        title: 'BBC',
        id: 'BBC'
      }];

    this.watchRoutes();
  }

  // communicated objects
  watchRoutes() {
    this.apiUserService.routerSubject.subscribe((val) => {
      this.currentRoute = val;
    });
  }

  // updating organization
  setUpdatableOrg(org) {
    this.updatableOrgSubject.next(org);
  }

  buildHeaders(type: string) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    switch (type) {
      case 'code_token':
        headers.append('Authorization', localStorage.getItem('code_token'));
        break;
      case 'wp':
        headers.append('Authorization', this._wpAuth);
        break;
      default:
        break;
    }
    return headers;
  }

  getOrganizations(orgId, caller): Observable<any[]> {
    const headers = this.buildHeaders('code_token');

    let url = this._orgUrl;
    let initialOrgs;
    let orgList;

    // if populating modal window
    if (caller === 'modal') {
      if (this.userService.currentUser.role === 'superadmin') {
        initialOrgs = this.organizations;
      } else if (this.userService.currentUser.role === 'admin') {
        initialOrgs = this.organizations[1];
      }
    } else {
      initialOrgs = null;
    }

    if (orgId !== undefined && orgId !== null) {
      url = this._apiUsers + '?organization_id=' + orgId;
    }

    return this.http
      .get(
        url,
        {headers})
      .map((res: Response) => {
        // append initial orgs
        if (initialOrgs !== null) {
          orgList = res.json().concat(initialOrgs);
        } else {
          orgList = res.json();
        }
        return orgList;
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });
  }

  createOrganizations(body: Object): Observable<any[]> {
    const headers = this.buildHeaders('code_token');

    return this.http
      .post(
        this._orgUrl,
        JSON.stringify(body),
        {headers})
      .map((res: Response) => {
        this.newOrgSubject.next(res.json());
        this.msgService.sendMessage(res);
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });
  }


  updateOrganizations(body: Object, id) {
    const headers = this.buildHeaders('code_token');

    return this.http
      .put(
        this._orgUrl + '/' + id,
        JSON.stringify(body),
        {headers})
      .map((res: Response) => {
        this.msgService.sendMessage(res);
        return res.json();
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });
  }

  deleteOrg(org) {
    const headers = this.buildHeaders('code_token');

    return this.http
      .delete(
        this._orgUrl + '/' + org.id,
        {headers})
      .map((res: Response) => {
        this.msgService.sendMessage(res);
        return res.json();
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });
  }

  getContracts() {
    let headers = this.buildHeaders('wp');

    return this.http
      .get(
        this._contractUrl,
        {headers})
      .map((res) => {
        return res.json();
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });
  }

    getReport() {
        let headers = this.buildHeaders('wp');

        return this.http
            .get(
                this._contractUrl,
                {headers})
            .map((res) => {
                return res.json();
            })
            .catch((error: Response) => {
                this.msgService.sendMessage(error);
                return Observable.throw(error);
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/service/organization.service.ts